import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { width = 24, height = 24, color = '#363531' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.25 4.5a.75.75 0 000 1.5h15a1.5 1.5 0 011.5 1.5v4.125a.75.75 0 01-1.5 0V7.5h-15a2.25 2.25 0 01-.75-.129v9.879a.75.75 0 00.75.75H11a.75.75 0 010 1.5H4.25A2.25 2.25 0 012 17.25v-12A2.25 2.25 0 014.25 3H17a.75.75 0 010 1.5H4.25zM21.696 14.12a.75.75 0 01.75.75v1.97a.75.75 0 01-.75.75h-1.969a.75.75 0 010-1.5h1.219v-1.22a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M17.75 15.141a2.854 2.854 0 00-2.02.838.75.75 0 01-1.062-1.06 4.355 4.355 0 016.163 0l1.394 1.39a.75.75 0 11-1.059 1.061l-1.394-1.39-.002-.001a2.855 2.855 0 00-2.02-.838zM13.054 19.16a.75.75 0 01.75-.75h1.97a.75.75 0 010 1.5h-1.22v1.22a.75.75 0 01-1.5 0v-1.97z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M13.273 18.631a.75.75 0 011.06-.002l1.395 1.391.002.001a2.856 2.856 0 004.04 0 .75.75 0 111.062 1.06 4.356 4.356 0 01-6.163 0l-1.394-1.39a.75.75 0 01-.002-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
